import styled from "@emotion/styled";
import { T, display, body } from "./theme";

export const Page = styled.div`
  background: ${T.paper};
  min-height: 100vh;
  width: 100%;
  font-family: ${body};
`;

export const Container = styled.div`
  max-width: 600px;
  margin: 0 auto;
  padding: 24px 16px;
`;

export const HeaderWrap = styled.header`
  margin-bottom: 16px;
`;

export const Eyebrow = styled.div`
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.14em;
  color: ${T.pine};
  margin-bottom: 12px;
`;

export const Title = styled.div`
  font-family: ${display};
  font-size: 1.5rem;
  line-height: 1.15;
  font-weight: 700;
  color: ${T.ink};
  margin: 0;
`;

export const Section = styled.section`
  background: ${T.surface};
  border: 1px solid ${T.line};
  border-radius: 16px;
  padding: 16px;
`;

export const FieldGroup = styled.div`
  margin-bottom: ${(props) => props.spacing || 16}px;
`;

export const NoAccessBanner = styled.div`
  text-align: center;
  padding: 14px 16px;
  border-radius: 10px;
  background: ${T.dangerSoft};
  color: ${T.danger};
  font-size: 14px;
  font-weight: 600;
`;

export const ResultWrap = styled.div`
  margin-top: 32px;
  padding-top: 32px;
  border-top: 1px solid ${T.line};
`;

export const ResultsHeading = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: ${T.ink};
  margin-bottom: 12px;
`;

export const ResultsRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ResultCard = styled.div`
  background: ${(props) => (props.secondary ? `none` : T.pineSoft)};
  border: 1px solid ${(props) => (props.secondary ? T.line : T.pine)};
  border-radius: 12px;
  padding: ${(props) => (props.secondary ? 16 : 20)}px;
`;

export const ResultLabel = styled.div`
  font-size: ${(props) => (props.secondary ? 11 : 12)}px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  color: ${(props) => (props.secondary ? T.inkFaint : T.pine)};
`;

export const ResultValue = styled.div`
  margin-top: ${(props) => (props.secondary ? 8 : 12)}px;
  font-family: ${display};
  line-height: 1.02;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  font-size: ${(props) => (props.danger ? 24 : props.secondary ? 26 : 36)}px;
  color: ${(props) => (props.danger ? T.danger : props.secondary ? T.inkSoft : T.pine)};
`;

export const Disclaimer = styled.div`
  margin-top: 8px;
  font-size: 12px;
  line-height: 1.4;
  color: ${T.inkFaint};
`;

export const ShareRow = styled.div`
  margin-top: 24px;
  text-align: center;
`;

export const globalStyles = `
  .rm-btn:focus-visible { outline: 2px solid ${T.pine}; outline-offset: 2px; }
  .rm-btn:hover:enabled { filter: brightness(1.06); }
  .rm-spin { animation: rmspin 1s linear infinite; }
  @keyframes rmspin { to { transform: rotate(360deg) } }
  @media (prefers-reduced-motion: reduce) { * { transition: none !important; animation: none !important } }
`;
